import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Uuid } from '../shared/classes/uuid';
import { AppInsightsService } from '../shared/services/app-insights.service';
import { SnEnvService } from '@insight/serenity-env';
import { SnAuthService } from '@insight/serenity-auth';

export interface HttpOptions {
  headers?: HttpHeaders | {
      [header: string]: string | string[];
  };
  observe?: 'body';
  params?: HttpParams | {
      [param: string]: string | string[];
  };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}

@Injectable()
export class HttpService {
  constructor(
    private _httpClient: HttpClient,
    private _authService: SnAuthService,
    private _appInsightsService: AppInsightsService,
    private _envService: SnEnvService) {
  }

  // ------------------------------------------------------------

  get<T>(url: string, options?: HttpOptions): Observable<T> {
    const requestOptions = this.getOptionObject(options);
    return this._httpClient.get<T>(url, requestOptions);
  }

  // ------------------------------------------------------------

  post<T>(url: string, body: any, options?: HttpOptions): Observable<T> {
    const requestOptions = this.getOptionObject(options);
    return this._httpClient.post<T>(url, body, requestOptions);
  }

  // ------------------------------------------------------------

  put<T>(url: string, body: any, options?: HttpOptions): Observable<T> {
    const requestOptions = this.getOptionObject(options);
    return this._httpClient.put<T>(url, body, requestOptions);
  }

  // ------------------------------------------------------------

  delete<T>(url: string, options?: HttpOptions): Observable<T> {
    const requestOptions = this.getOptionObject(options);
    return this._httpClient.delete<T>(url, requestOptions);
  }

  // ------------------------------------------------------------

  private getOptionObject(options?: HttpOptions) {
    let headersObj: HttpHeaders;

    if (!options) {
      options = {};
    }

    if (options.headers) {
      headersObj = options.headers as HttpHeaders;
    } else {
      headersObj = new HttpHeaders();
    }

    const traceId = this._appInsightsService.context && this._appInsightsService.context.operation.id
                    ? this._appInsightsService.context.operation.id : Uuid.createV4();

    console.log('traceId', traceId);

    headersObj = headersObj
        // .append('Ocp-Apim-Subscription-Key', this._envService.get('api_subscription_key'))
        // .append('Ocp-Apim-Trace', 'true')
        .append('Audience', 'http://api.ecova.com/api/common-utility-bill') // Need to Change this
        .append('request-id', traceId);
    options.headers = headersObj;
    return options;
  }
}

class TokenExchangeResponse {
  public access_token: string;
}
